import React, { useEffect, useState } from 'react'
import GlobalSearchPopup from 'Popups/GlobalSearchPopup/GlobalSearchPopup';
import { IoSearch } from "react-icons/io5";
import { Tooltip } from 'react-tooltip'
const GlobalSearch = () => {
    const [globalPopup, setGlobalPopup] = useState(false)
    const openGlobalPopup = () => {
        setGlobalPopup(true)
    }
    const closeGlobalPopup = () => {
        setGlobalPopup(false)
    }
    useEffect(() => {
        const handleKeyDown = (event) => {
            // Check if the target is an input, textarea, or a contenteditable element
            const target = event.target;
            const isInputField =
                target.tagName === 'INPUT' ||
                target.tagName === 'TEXTAREA' ||
                target.isContentEditable;

            if (isInputField) return; // Exit if focused on an input field

            if (event.key === '/') {
                event.preventDefault(); // Prevent default browser behavior
                setGlobalPopup(true);
            }

            if (event.key === 'Escape') {
                setGlobalPopup(false);
            }
        };

        window.addEventListener('keydown', handleKeyDown);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, []);
    return (
        <div className='grow'>
            {globalPopup && (<GlobalSearchPopup isVisible={globalPopup} onClose={closeGlobalPopup} />)}
            <button className='relative px-10 py-2 text-left rounded w-[370px] text-secondaryLight hover:shadow-4 bg-gray-50' onClick={openGlobalPopup} >
                <IoSearch className='absolute font-semibold top-2 left-3 text-secondaryLight' size={20} />
                Search patients, claims or payments
                <div data-tooltip-id={"globalSearch_tooltip"} data-tooltip-content="Press / key to Search" className='absolute px-3 py-[2px] border  font-bold bg-white rounded   right-3 top-1'>/</div>
                <Tooltip id="globalSearch_tooltip" />

            </button>
        </div>
    )
}

export default GlobalSearch